module.exports = __webpack_public_path__ + "static/media/mixar.cb93b669.jpg";